var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Col, Modal, ModalBody, Row } from 'reactstrap';
import theme from 'Theme';
import { RenderTicket, TypeAction } from '../../../components/Ticket/Ticket';
import { T } from '../../../helpers/i18n';
let TicketRenderModal = class TicketRenderModal extends Component {
    constructor() {
        super(...arguments);
        this.handleRefund = (ticket) => {
            ticket = toTotalesNegativo(ticket);
            this.props.store.reports.cancelTicket(ticket, this.props.store.users.user)
                .then((value) => {
                alert(value.message);
                this.props.onToggle();
                if (this.props.onRefunded) {
                    if (value.result === 'ok') {
                        this.props.onRefunded(value);
                    }
                }
            })
                .catch(error => {
                // alert(error.message)
                console.log('handleRefund - error: ', error);
                this.props.store.UI.newError('se ha producido un error, intentelo más tarde');
            });
        };
        this.handleChangeInput = (method, input) => {
            const _value = input.currentTarget.value;
            // console.log('method: ', method)
            // console.log('input: ', _value)
            if (_value === '') {
                return;
            }
            const numero = Number(_value);
            console.log('numero: ', numero);
            if (Number.isNaN(numero)) {
                return this.props.store.UI.newWarning('Valor introducido no válido');
            }
            this.props.store.tempDuePaymentsStore.setPayment(method, numero);
        };
        this.handleOnclick = (action, ticket) => {
            console.log('handleOnclick - action: ', action);
            if (!action) {
                return;
            }
            switch (action) {
                case TypeAction.ShowPay:
                    break;
                case TypeAction.Refund:
                    if (confirm(T('refundAsk'))) {
                        this.handleRefund(ticket);
                    }
                    break;
                case TypeAction.Pay:
                    this.handlePayment();
                    break;
                default:
            }
            return;
        };
        this.handlePayment = () => {
            console.log('handlePayment');
            const { store } = this.props;
            store.tempDuePaymentsStore.user = store.users.user;
            store.tempDuePaymentsStore.send(this.props.ticket)
                .then(value => {
                if (value.result === 'ok') {
                    store.UI.newWarning('Pago realizado correctamente');
                    store.reports.readTicketsUser(store.users.user.id);
                }
                else {
                    store.UI.newWarning(value.message);
                }
                this.props.onToggle();
            })
                .catch(error => store.UI.newError('Se ha producido un error, por favor contacte con el servido técnico, eroor 589'));
        };
    }
    render() {
        var _a;
        const itemList = [];
        const item = this.props.ticket;
        // item.image = `${process.env.REACT_APP_SERVER}${item.image}`
        itemList.push(item);
        if ((_a = this.props.ticket) === null || _a === void 0 ? void 0 : _a.ticketRefunded) {
            const temp = this.props.ticket.ticketRefunded;
            temp.image = item.image;
            itemList.push(temp);
        }
        const externalCloseBtn = React.createElement("button", { className: "close", style: { color: theme.color.primary, position: 'absolute', top: '50px', right: '15px', fontSize: 60, opacity: 1 }, onClick: this.props.onToggle }, "\u00D7");
        return (React.createElement("div", { className: "animated fadeIn " },
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Modal, { centered: true, fade: true, isOpen: true, modalTransition: { timeout: 700 }, backdropTransition: { timeout: 1000 }, toggle: this.props.onToggle, external: externalCloseBtn, style: { width: !itemList ? '320px' : `${itemList.length * 320}px`, minWidth: !itemList ? '320px' : `${itemList.length * 300}px` } },
                        React.createElement(ModalBody, { style: { padding: 0, opacity: 1 } },
                            React.createElement("div", { style: { display: 'flex', flexDirection: 'row' } }, itemList.map((value, index) => {
                                return (React.createElement(RenderTicket, { showPaymentMethod: value.totalDue > 0, key: index, ticket: value, onClick: this.handleOnclick, onPay: this.handleChangeInput, index: index }));
                                // return RenderTicket(value, this.handleRefund,index)
                            }))))))));
    }
};
TicketRenderModal = __decorate([
    inject('store'),
    observer
], TicketRenderModal);
// true si es para el mismo dia y mes y año
// false porque tiene time
export const fechasIguales = (date1, date2) => {
    return date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate();
};
const toTotalesNegativo = (ticket) => {
    ticket.lines.forEach(line => {
        line.taxBase = 0 - line.taxBase;
        line.taxAmount = 0 - line.taxAmount;
        line.total = 0 - line.total;
    }); // TODO cancelado total
    ticket.payments.forEach(payment => {
        payment.amount = 0 - payment.amount;
    }); // TODO cancelado total
    ticket.total = 0 - ticket.total;
    ticket.taxAmount = 0 - ticket.taxAmount;
    ticket.netAmount = 0 - ticket.netAmount;
    return ticket;
};
export default TicketRenderModal;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/TicketRenderModal.tsx
// module id = 233
// module chunks = 0